import { useEffect, useState } from "react";

export const useDesktopViewport = () => {
  const [isDesktopViewport, setIsDesktopViewport] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const mediaQuery = window.matchMedia("(min-width: 768px)");
    const updateViewport = () => setIsDesktopViewport(mediaQuery.matches);
    updateViewport();

    mediaQuery.addEventListener?.("change", updateViewport);
    return () => {
      mediaQuery.removeEventListener?.("change", updateViewport);
    };
  }, []);

  return isDesktopViewport;
};
